import { render, staticRenderFns } from "./VueEmailModal.vue?vue&type=template&id=cc2c8be2&scoped=true"
import script from "./VueEmailModal.vue?vue&type=script&lang=js"
export * from "./VueEmailModal.vue?vue&type=script&lang=js"
import style0 from "./VueEmailModal.vue?vue&type=style&index=0&id=cc2c8be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2c8be2",
  null
  
)

export default component.exports